import { UserGroup, UserGroupType } from './UserGroup';
export class BillingGroup extends UserGroup {
    constructor() {
        super(...arguments);
        this.groupType = UserGroupType.BillingGroup;
    }
}
